<div class="document-content" *ngIf="showDocumentContent">
  <div class="document-content-header">
    <img width='24' height='24' alt="{{ document.mimeType }}" src="{{ document.mimeType | adfMimeTypeIcon }}"/>
    <span class="document-name" title="{{document.name}}">{{document.name}}</span>
    <button mat-icon-button (click)='downloadContent($event, document.id, document.name)'><mat-icon>download</mat-icon></button>
    <button mat-icon-button (click)='openViewer()'><mat-icon>zoom_out_map</mat-icon></button>
  </div>
  <div class="document-content-body">
    <ng-container *ngIf="previewBlobUrl; else previewLoading">
      <pdf-viewer [@fadeInOut]="previewBlobUrl ? 'visible' : 'hidden'"
                  [src]="previewBlobUrl"
                  [original-size]="false"
                  [show-all]="true"></pdf-viewer>
    </ng-container>
  </div>
</div>

<div class="document-container" (click)="openViewer()" *ngIf="!showDocumentContent">
  <div class="document-thumbnail" title="{{document.name}}">
    <ng-container *ngIf="thumbnailBlobUrl$ | async as thumbnailBlobUrl; else loading">
      <img class="thumbnail" *ngIf="thumbnailBlobUrl" [src]="thumbnailBlobUrl" />
    </ng-container>
  </div>
  <div class="document-details">
    <div class="document-name" title="{{document.name}}">
      {{document.name}}
    </div>
    <span class="document-date mat-caption">
      <img width='24' height='24' alt="{{ document.mimeType }}" src="{{ document.mimeType | adfMimeTypeIcon }}"/>
      {{document.created | date: "dd.MM.yyyy HH:mm" }}
    </span>
  </div>
  <div class="document-download-button" #download_button>
    <button mat-icon-button tabindex="-1" (click)="downloadContent($event, document.id, document.name)" title="{{'TOOLTIP.DOWNLOAD' | translate}}">
      <mat-icon>download</mat-icon>
    </button>
  </div>
</div>

<ng-template #dialogTemplate>
  <div class="dialog-actions">
    <div class="document-details">
      <div class="document-name" title="{{document.name}}">
        {{document.name}}
      </div>
      <span class="document-date mat-caption">
        <img width='24' height='24' alt="{{ document.mimeType }}" src="{{ document.mimeType | adfMimeTypeIcon }}"/>
        {{document.created | date: "dd.MM.yyyy HH:mm" }}
      </span>
    </div>
    <button mat-icon-button class="dialog-header-button mat-icon-button-modal" tabindex="-1" (click)="downloadContent($event, document.id, document.name)" title="{{'TOOLTIP.DOWNLOAD' | translate}}">
      <mat-icon>download</mat-icon>
    </button>
    <button mat-icon-button class="pull-right-lg mat-icon-button-modal" tabindex="-2" (click)='closeViewer()'>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <ng-container *ngIf="previewBlobUrl; else previewLoading">
      <pdf-viewer [@fadeInOut]="previewBlobUrl ? 'visible' : 'hidden'"
                  [src]="previewBlobUrl"
                  [original-size]="false"
                  [render-text]='true'
                  [show-all]="true"
                  [fit-to-page]="false">
      </pdf-viewer>
    </ng-container>
  </div>
</ng-template>

<ng-template #previewLoading>
  <ng-container *ngIf="thumbnailBlobUrl$ | async as thumbnailBlobUrl; else loading">
    <div class="thumbnail-container" *ngIf="thumbnailBlobUrl">
      <img [src]="thumbnailBlobUrl" class="thumbnail"/>
    </div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="thumbnail spinner">
    <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
